import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 2,
  overflow: 'hidden',
  border: '1px solid #ddd',
  background: 'white',
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#EEF7FF',
    fontWeight: 'bold',
    fontSize: '0.95rem',
  },

  '& .MuiDataGrid-footerContainer': {
    backgroundColor: '#EEF7FF', 
    fontWeight: 500,
  },

  '& .MuiDataGrid-row:hover': {
    backgroundColor: '#B6BBC4',
  },

  '& .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
}));

const VemigoGrid = ({ rows, columns }) => {
  const allOption = rows?.length > 0 ? rows.length : 10;

  return (
    <StyledDataGrid
      rows={rows}
      columns={columns}
      autoHeight
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[10, 20, { label: 'All', value: allOption }]}
      getRowId={(row) => row.id || row._id || Math.random()}
      sx={{
        marginTop: '10px',
        borderRadius: 2,
        border: '1px solid #ddd',
      }}
    />
  );
};

export default VemigoGrid;
